import React from 'react'
import PrivacyPage from 'components/PrivacyPage'
import { items } from './index'
import { ProductInfoItem } from 'components/ProductInfo'
import { getDocumentHead } from 'components/DocumentHead'

const androidSections: ProductInfoItem[] = [
  {
    header: '7. Sensitive Information and Permissions',
    text: 'In order to provide you with enhanced functionality, Control D may request background location permissions to enable the "Excluded Networks" feature. This functionality is specifically designed to apply per-network settings to your DNS configuration by accessing your Network SSID (Service Set Identifier).',
  },
  {
    subheader: '7.1 Usage of Location Data',
    text: 'Your location data, including the Network SSID, is collected solely for the purpose of configuring and applying per-network settings within the Control D application. It is important to note that your location data will remain stored locally on your device and will not be transmitted to any external servers or third parties.',
  },
  {
    subheader: '7.2 User Control and Choices',
    text: 'You have the option to deny this permission at any time through your device settings, providing you with full control over the access granted to our application.',
  },
  {
    subheader: '7.3 Data Sharing',
    text: 'Under no circumstances will your location data be shared with any third party. It is strictly used for the internal functionality of Control D as described in this section.',
  },
]
export default function Android(): React.ReactElement {
  return <PrivacyPage items={[...items, ...androidSections]} />
}

export const Head = getDocumentHead({
  title: 'Privacy',
  description:
    'Control D prioritizes your privacy and data security. Our comprehensive privacy policy clearly outlines what data is collected, stored and why.',
})
